import MyCollapse from "../../components/MyCollapse";

const AboutUs02 = () => {
  const content = [
    {
      value: 1,
      title: "임신 중 산전 진단이 중요한 이유는 무엇인가요?",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text ac1-2">
            <div className="top">
              <span>
                <img
                  src="/assets/img/icon/02-01.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <p>
                CDH 진단을 받은 신생아는 예외 없이 신생아 중환자실 치료가
                필요하므로, 태아 시기의 정확한 진단이 매우 중요합니다. 대부분의
                경우 임신 중반기 이후에 산전 초음파를 통해 발견됩니다. 초음파
                검사로 복부 장기(위, 장, 간, 비장 등)가 흉곽에 위치한 것을
                확인할 수 있으며, 탈장이 발생한 쪽의 폐는 탈장된 장기로 인해
                눌리게 되므로 대부분 잘 관찰되지 않습니다. 또한, 심장의 위치가
                왼쪽 또는 오른쪽으로 밀리거나, 양수량이 증가하는 양수 과다증이
                동반되기도 합니다.
              </p>
            </div>
          </div>
        </div>
      ),
    },
    {
      value: 2,
      title: "초음파 검사로는 무엇을 알 수 있나요?",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text ac1-2" style={{ marginBottom: 10 }}>
            <div className="top" style={{ marginBottom: 10 }}>
              <span>
                <img
                  src="/assets/img/icon/02-02.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <dl style={{ paddingLeft: 0, marginTop: 0 }}>
                <dt>01</dt>
                <dd>
                  <h2>폐 발달 정도 평가</h2>
                  <p>
                    CDH로 진단되면 위험도를 평가하게 됩니다. 탈장이 발생하지
                    않은 반대쪽 폐의 발달 정도가 출생 후 아기 상태를 예측하는
                    중요한 요인으로 알려져 있습니다. 폐-머리
                    비율(observed/expected lung to head ratio, O/E LHR)은 생존을
                    가장 잘 예측할 수 있는 지표로 알려져 있으며 초음파 검사로
                    측정 가능합니다.
                  </p>
                </dd>
              </dl>
            </div>
            <div className="top">
              <dl  style={{ paddingLeft: 0, marginTop: 0 }}>
              <dt style={{borderBottom:"0px"}}>&nbsp;</dt>
                <dd>
                  <p>
                    왼쪽 탈장의 경우, O/E LHR이 25% 미만일 때 생존율은 10~20%
                    정도로 매우 낮지만, 45% 이상일 경우 생존율은 90% 이상으로
                    매우 좋습니다. 우측 탈장의 경우, 경과가 상대적으로 좋지
                    않으며 O/E LHR이 45% 미만일 경우 생존율이 매우 낮습니다. MRI
                    또한 태아 폐의 크기와 부피를 정확하게 평가하는 데
                    사용됩니다. 특히 임신 후반기에는 태아의 위치, 골격 음영(bone
                    shadowing)으로 인해 초음파로 태아의 폐를 정확히 평가하기
                    어려울 수 있는데, 이때는 MRI를 통해 보다 정확한 평가가
                    가능합니다. 그 외에도 간의 탈장 유무와 위의 위치를 확인하는
                    것이 예후를 예측하는 데 도움이 됩니다.
                  </p>
                </dd>
              </dl>
            </div>
          </div>
          <div className="ac_text ac3-2">
            <dl>
              <div className="img">
                <img
                  src="/assets/img/ac3-1.png"
                  width=""
                  alt=""
                  className="pc"
                />
                <img src="/assets/img/mac3-1.png" alt="" className="mob" />
              </div>
            </dl>
            <h5>
              [O/E LHR과 간 탈장 유무에 따른 좌측 횡격막 탈장 환아의 생존률
              (검은색: 간 탈장 있음, 회색: 간 탈장 없음, 흰색: 태아 치료 시)]
            </h5>
            <dl>
              <dt>02</dt>
              <dd>
                <h2>동반 기형 및 염색체 이상 여부 평가</h2>
                <p>
                  CDH에서는 선천성 심장병과 같은 다른 기형이 동반될 수 있으며,
                  이러한 경우 염색체 이상을 의심하여 양수검사를 시행할 수
                  있습니다. 동반된 구조적 기형이나 염색체 이상이 있을 경우,
                  예후가 더 좋지 않을 수 있습니다.
                </p>
              </dd>
            </dl>
          </div>
        </div>
      ),
    },
    {
      value: 3,
      title: "태아치료(Fetoscopic Endotracheal Occlusion, FETO)란 무엇인가요?",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text ac1-2">
            <div className="top">
              <span>
                <img
                  src="/assets/img/icon/02-03.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <p>
                일부 국가에서는 폐 형성 부전이 심한 경우, 태아 내시경을 이용해
                태아의 기관지에 일시적으로 풍선을 삽입하여 기도를 폐쇄함으로써
                폐 발달을 촉진시키는 태아치료를 시행하고 있습니다. 현재 이
                치료는 해외에서도 제한된 병원에서만 시행되며, 국내에서는 시술에
                필요한 풍선을 확보하는 데 어려움이 있어 아직 시행되지 못하고
                있습니다.
              </p>
            </div>
          </div>
        </div>
      ),
    },
    {
      value: 4,
      title: "꼭 큰 병원에서 아기를 낳아야 할까요?",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text ac1-2">
            <div className="top">
              <span>
                <img
                  src="/assets/img/icon/02-04.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <p>
                아기가 태어나기 전에는 다른 합병증이 생기지 않는지 주의 깊게
                살피고 적절한 분만 시기를 결정하기 위해 정기적인 산전 관리를
                받는 것이 중요합니다. 출산 시기가 대략 결정되면 CDH 집중 치료의
                경험이 풍부한 신생아 의사와 이에 대한 수술 경험이 있는 소아외과
                의사가 있는 지역의 대학병원 산부인과에서 아기를 분만하는 것이
                필요합니다. 다만, 산전 진단에서 매우 낮은 폐-머리 비율을 보이는
                등 출생 직후 아기 상태가 안 좋을 것으로 예상되는 경우 인공심폐기
                (체외막 산소요법, ECMO)가 가능한 소수 대형병원으로 산모를 옮겨
                아기를 분만할 것을 권장합니다. 아기 상태가 매우 나쁘면 아기를
                다른 병원으로 옮기는 것이 불가능할 수도 있기 때문입니다.
              </p>
            </div>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="acco">
      <MyCollapse data={content} />

      <div className="ac_text">
        <div className="info_text">
          <p>
            CDH는 산전 진단과 평가를 통해 비교적 정확하게 신생아기 경과를 예측할
            수 있는 질환입니다. 인공호흡기 치료, 심장에 대한 평가와 수술이
            반드시 필요하므로 신생아 전문의와 소아심장과 전문의 진료가 가능한
            신생아 중환자실이 있고 수술의 경험이 풍부한 소아외과의사가 있는 큰
            병원에서 분만 계획을 세우는 것이 매우 중요합니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs02;
